import { axiosAuth, axiosPlatform } from "../../_services/axios-helper";

export const refreshBasicDataRequest = () => {
    return axiosPlatform().get("/commons/refresh_user_data");
};

export const getAllCommonsRequest = () => {
    return axiosPlatform().get("/commons");
};

export const sendFeedbackMessageRequest = (feedbackMessage) => {
    return axiosPlatform().post("/commons/feedback", { message: feedbackMessage });
};

export const fetchPreferredIdentifierMethodsRequest = (integration) => {
    return axiosPlatform().get("/commons/accountingidentifiermethods/" + integration);
};

export const createSupportTicketRequest = (payload) => {
    return axiosAuth().post("/hubspot/ticket", payload);
};
